export function getQuery(id: string) {
  return `
  {
    queryTabelasDinamicasContents(filter: "id eq '${id}'") {
      flatDataDraft {
        name
        header
        textAfter
        textBefore
        data {
          flatData {
            content
          }
        }
      }
    }
  }
  `;
}
